import { useContext } from 'react'
import DishesDataContext from './DishesDataContext'


const useDishesData = () => useContext(DishesDataContext)
export default useDishesData
